import type { IntlFormatters } from "@formatjs/intl/src/types";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

export default function parseString(field: IProperty, formatMessage: IntlFormatters["formatMessage"] = () => "") {
    let schema = z.string().trim();

    if (field?.minLength) schema = schema.min(field.minLength);
    if (field?.maxLength) schema = schema.max(field.maxLength);
    if (field?.pattern) {
        const numbersOnly = field.pattern === "^-?[0-9]*$";
        const messageId = numbersOnly ? "errors.invalid_string.patternNumberOnly" : "errors.invalid_string.pattern";

        schema = schema.regex(new RegExp(field.pattern), {
            error: formatMessage({
                id: messageId,
            }),
        });
    }

    return schema;
}
